var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.297,
    height: 27.297,
    viewBox: "0 0 27.297 27.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_ios-24px",
    transform: "translate(0 27.297) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M0,0H27.3V27.3H0Z",
    fill: "none",
    opacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M18.045,3.04a1.421,1.421,0,0,0-2.013,0L6.58,12.492a1.133,1.133,0,0,0,0,1.6l9.452,9.452a1.424,1.424,0,0,0,2.013-2.013L9.81,13.288l8.246-8.246A1.418,1.418,0,0,0,18.045,3.04Z",
    transform: "translate(0.858 0.36)",
    fill: "#474b59"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcon);
export default __webpack_public_path__ + "static/media/upIcon.d4290f8f.svg";
export { ForwardRef as ReactComponent };